import { gql } from '@apollo/client';

export const getOrganizationTypes = gql`
  query getOrganizationTypes {
    organizationTypes(filter: { state: { _eq: ACTIVE } }) {
      totalCount
      edges {
        node {
          id
          oid
          name
        }
      }
    }
  }
`;
